// extracted by mini-css-extract-plugin
export default {"sign-up":"SignUp_sign-up__M45oj"};